// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.styles_main__kZdwD{

}
.styles_child__LzUmB{
  margin: 64px clamp(150px,3vw,194px) 0 clamp(150px,3vw,194px);
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: 390;
  font-size: 22px;
  line-height: 31px;  
  width: 80%;
  max-width: 1920px;
  margin-inline: auto ;
}



.styles_child__LzUmB > ul {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  margin-bottom: 41px;
  list-style: none;
}

.styles_listChild__nyt3P{
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: 10px;
  margin-bottom: 10px;
  
}

.styles_listChild__nyt3P > figure {
  margin: auto;
}

.styles_listItemChild__jymvu > ul{
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin: auto;
}

.styles_listItemChild__jymvu > span {
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 31px;
  color: var(--color-primary-black);
}

@media screen and (max-width: 1280px ){
.styles_child__LzUmB{
  margin: 64px clamp(100px,3vw,150px) 0 clamp(100px,3vw,150px);
  font-size: clamp(18px,3vw,23px);
 
}
}

@media screen and (max-width: 820px ){

  .styles_frame__JsB86{
    margin-top: 100px;
  }
  .styles_frame__JsB86 > p{
    margin: 0 clamp(69px,3vw,122px);
    font-size: clamp(18px,2vw,30px);

  }
  .styles_child__LzUmB{
    margin: 64px clamp(40px,3vw,100px) 0 clamp(40px,3vw,100px);
    font-size: clamp(18px,3vw,23px);
   
  }
  .styles_listChild__nyt3P > figure > img{
    width: clamp(264px,2vw,357px);

    
  }
}

.styles_howAlinWorkContent__vM0pb {
  margin-top: 150px
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/styles.module.css"],"names":[],"mappings":";AACA;;AAEA;AACA;EACE,4DAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,oBAAoB;AACtB;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;AACA;EACE,4DAA4D;EAC5D,+BAA+B;;AAEjC;AACA;;AAEA;;EAEE;IACE,iBAAiB;EACnB;EACA;IACE,+BAA+B;IAC/B,+BAA+B;;EAEjC;EACA;IACE,0DAA0D;IAC1D,+BAA+B;;EAEjC;EACA;IACE,6BAA6B;;;EAG/B;AACF;;AAEA;EACE;AACF","sourcesContent":["\n.main{\n\n}\n.child{\n  margin: 64px clamp(150px,3vw,194px) 0 clamp(150px,3vw,194px);\n  display: flex;\n  flex-direction: column;\n  font-style: normal;\n  font-weight: 390;\n  font-size: 22px;\n  line-height: 31px;  \n  width: 80%;\n  max-width: 1920px;\n  margin-inline: auto ;\n}\n\n\n\n.child > ul {\n  display: flex;\n  flex-direction: column;\n  row-gap: 40px;\n  margin-bottom: 41px;\n  list-style: none;\n}\n\n.listChild{\n  padding: 0 15px;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  row-gap: 10px;\n  margin-bottom: 10px;\n  \n}\n\n.listChild > figure {\n  margin: auto;\n}\n\n.listItemChild > ul{\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n  margin: auto;\n}\n\n.listItemChild > span {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 22px;\n  line-height: 31px;\n  color: var(--color-primary-black);\n}\n\n@media screen and (max-width: 1280px ){\n.child{\n  margin: 64px clamp(100px,3vw,150px) 0 clamp(100px,3vw,150px);\n  font-size: clamp(18px,3vw,23px);\n \n}\n}\n\n@media screen and (max-width: 820px ){\n\n  .frame{\n    margin-top: 100px;\n  }\n  .frame > p{\n    margin: 0 clamp(69px,3vw,122px);\n    font-size: clamp(18px,2vw,30px);\n\n  }\n  .child{\n    margin: 64px clamp(40px,3vw,100px) 0 clamp(40px,3vw,100px);\n    font-size: clamp(18px,3vw,23px);\n   \n  }\n  .listChild > figure > img{\n    width: clamp(264px,2vw,357px);\n\n    \n  }\n}\n\n.howAlinWorkContent {\n  margin-top: 150px\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `styles_main__kZdwD`,
	"child": `styles_child__LzUmB`,
	"listChild": `styles_listChild__nyt3P`,
	"listItemChild": `styles_listItemChild__jymvu`,
	"frame": `styles_frame__JsB86`,
	"howAlinWorkContent": `styles_howAlinWorkContent__vM0pb`
};
export default ___CSS_LOADER_EXPORT___;
